// extracted by mini-css-extract-plugin
export default {"popup":"PopupEdit_popup__2Vgo2","popSpread":"PopupEdit_popSpread__EK1ns","popHighlight":"PopupEdit_popHighlight__4iSUI","popupEdit":"PopupEdit_popupEdit__TbG24"};